import PropTypes from 'prop-types';
import stc from 'string-to-color';
import { cn } from 'Utils/cn';

export default function Avatar(props) {
    const { className, name = '' } = props;

    const backgroundColor = stc(name);
    const initials =
        typeof name === 'string'
            ? name
                  .split(' ')
                  .map((word) => word[0])
                  .slice(0, 2)
                  .join('')
            : '-';

    return (
        <div
            className={cn('rounded-md text-white size-8 inline-flex items-center justify-center font-bold', className)}
            style={{ backgroundColor }}
        >
            {initials}
        </div>
    );
}

Avatar.propTypes = {
    name: PropTypes.string,
    className: PropTypes.string,
};
